// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging, onMessage } from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDDvkik09rAJk3fMzJGuZbTW3COOHts3x4",
  authDomain: "ai-demo-c6fc0.firebaseapp.com",
  projectId: "ai-demo-c6fc0",
  storageBucket: "ai-demo-c6fc0.firebasestorage.app",
  messagingSenderId: "80078647020",
  appId: "1:80078647020:web:65b7dedc204d6beea93fc9",
  measurementId: "G-J3GB5P9DZS",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Messaging service
const messaging = getMessaging(app);

export { messaging, onMessage };

// Function to handle foreground messages
export const onForegroundMessage = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log("Received foreground message:", payload);
      resolve(payload);
    });
  });
